module.exports = __webpack_public_path__ + "static/rabbit0-a2f50dbb3a0a36c2fc899467b31442d0.webp";